import React, { useRef, useState } from "react";

import { useMutation } from "@apollo/client";

import { Loading } from "../components";
import CouponValidateMutation from "./CouponValidateMutation.js";

export default function EnterCoupon({
  className: publicClass,
  postId,
  setCouponvalid,
  date,
}) {
  const [error, setError] = useState();
  const [loading, setLoading] = useState();
  const inputref = useRef();
  const checktimeout = useRef();

  const [validate] = useMutation(CouponValidateMutation, {
    onCompleted(payload) {
      setLoading(false);

      const { couponValidate } = payload;
      setCouponvalid(couponValidate.valid);
      setError(!couponValidate.valid);
    },
    onError() {
      setCouponvalid(false);
      setError(true);
      setLoading(false);
    },
  });

  const check = (event) => {
    event.preventDefault();
    setLoading(true);

    clearTimeout(checktimeout.current);
    checktimeout.current = setTimeout(() => {
      validate({
        variables: {
          input: {
            date,
            couponcode: inputref.current.value,
            post_id: `${postId}`,
            clientMutationId: new Date().toString(32),
          },
        },
      });
    }, 3000);
  };

  let loadingClass = "w1 h1 relative z1";

  if (!loading) {
    loadingClass += " o-0";
  }

  return (
    <div className={publicClass}>
      <div className="flex items-center justify-center">
        <div className="mr3">Enter Coupon:</div>

        <div className="bb b--dark-gray flex items-end">
          <div>
            <input
              type="text"
              className="bn ttu"
              name="couponcode"
              onInput={check}
              style={{ outline: 0 }}
              ref={inputref}
            />
          </div>

          <div className={loadingClass}>
            <Loading
              style={{
                transform: "scale(0.65)",
                position: "absolute",
                bottom: 0,
                right: 0,
              }}
            />
          </div>
        </div>
      </div>

      {error && <div className="ttu red f6 fw7 tc mt2">Invalid Coupon</div>}
    </div>
  );
}
